import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useParams } from '../../data/hooks/useParams.hook'
import SmartGrid, { ColumnConfig } from '../../components/smartGrid/SmartGrid'
import { Param, paramsConstants } from '../../data/types/params.types'
import { Spinner } from '../../components/spinner/Spinner.component'

const entityConstants = paramsConstants

export const ParamsBrowse = () => {
	const { data, isPending, isError, error } = useParams()
	const navigate = useNavigate()
	const queryClient = useQueryClient()

	const columns: ColumnConfig[] = [
		{
			key: 'id',
			header: 'Parametro',
			dataType: 'text',
			filterable: true,
			sortable: true,
			horizontalAlign: 'left',
			width: 30
		},
		{
			key: 'value',
			header: 'Valor',
			dataType: 'text',
			filterable: false,
			sortable: false,
			horizontalAlign: 'left',
			width: 130
		}
	];

	const rowActions = [
		{
			label: '',
			action: (selected: Param[]) => navigate(`${entityConstants.navigateToParent}/${selected[0].id}`),
			icon: '✏️'
		}
	];

	if (isPending) return <Spinner />
	
	return (
		<div style={{ margin: '0 150px'}}>
			 {/* {isError && <div style={{ color: 'red' }}>Error: {error?.message}</div>} */}
			{(!isPending && !isError) && <SmartGrid
				data={data || []}
				columns={columns}
				pageSize={10}
				rowActions={rowActions}
				defaultSort={{ key: 'id', direction: 'asc' }}
				toolbarComponents={[
					{
						type: 'title',
						title: entityConstants.entityLabel
					},
				]}
			/>}
		</div>
	)
}